import { render, staticRenderFns } from "./AddAbsencesModal.vue?vue&type=template&id=6bcd5d82&scoped=true"
import script from "./AddAbsencesModal.vue?vue&type=script&lang=js"
export * from "./AddAbsencesModal.vue?vue&type=script&lang=js"
import style0 from "./AddAbsencesModal.vue?vue&type=style&index=0&id=6bcd5d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcd5d82",
  null
  
)

export default component.exports